module.exports = __webpack_public_path__ + "img/bullock-logo.946fc349.jpg";